import { loader } from "graphql.macro";

const mutations = {
  UPDATE_USER_STATUS: loader("./updateUserStatus.gql"),
  TERMINATE_USER: loader("./terminateUser.gql"),
  UPDATE_USER_FINAL_PAY: loader("./updateUserFinalPay.gql"),
  UPDATE_MANAGER_STATUS: loader("./updateManagerStatus.gql"),
  CREATE_MANAGER: loader("./createManager.gql"),
  GENERATE_PARTNER_REPORT: loader("./generatePartnerReport.gql"),
  CREATE_REWARD: loader("./createReward.gql"),
  UPLOAD_BATCH_ONBOARD_FILE: loader("./uploadBatchOnboard.gql"),
  UPLOAD_BATCH_DISBURSEMENT_FILE: loader("./uploadBatchDisbursement.gql"),
  UPLOAD_PAYROLL_JOURNAL_FILE: loader("./uploadPayrollJournal.gql"),
  UPLOAD_GROSS_EARNINGS_FILE: loader("./uploadGrossEarningsFile.gql"),
  CREATE_DISBURSEMENT: loader("./createDisbursement.gql"),
  GENERATE_DDU_REPORT: loader("./generateDDUReport.gql"),
  GENERATE_PAYROLL_ANOMALY_REPORT: loader("./generatePayrollAnomalyReport.gql"),
  CREATE_PARTNER_REPORT: loader("./createPartnerReport.gql"),
  GENERATE_REWARDS_REPORT: loader("./generateRewardsReport.gql"),
  CREATE_DDU_FILE: loader("./createDDUFile.gql"),
  GENERATE_BATCH_ONBOARD_URL: loader("./generateBatchOnboardUrl.gql"),
  UPDATE_EMPLOYEE_NOTIFICATION_SETTINGS: loader(
    "./updateEmployerNotificationSettings.gql"
  ),
  SWITCH_PROVIDER: loader("./switchProvider.gql"),
  UPDATE_DISBURSEMENT: loader("./updateDisbursement.gql"),
  UPDATE_BATCH_DISBURSEMENT: loader("./updateBatchDisbursement.gql"),
  EXPORT_PAYSTUB_REPORT: loader("./exportPaystubReport.gql"),
  EXPORT_CASH_BALANCE_REPORT: loader("./exportCashBalanceReport.gql"),
  EXPORT_DDU_CONSENT_REPORT: loader("./exportDDUConsentReport.gql"),
  EXPORT_PRESETTLEMENT_EXCLUSION_REPORT: loader(
    "./exportPresettlementExclusionReport.gql"
  ),
  EXPORT_BALANCE_DISTRIBUTOR_REPORT: loader(
    "./exportBalanceDistributorReport.gql"
  ),
  UPDATE_REWARD_BUDGET: loader("./updateEmployerRewardBudget.gql"),
  UPDATE_REWARD: loader("./updateReward.gql"),
  ENABLE_SMS_ONBOARDING: loader("./enableSmsOnboarding.gql"),
};

export default mutations;
